<script setup lang="ts">
defineProps({
  showMessage: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: null,
  },
})
</script>

<template>
  <div
    v-if="showMessage && message"
    class="flex w-full min-w-[90%] items-center justify-center opacity-100 transition-opacity duration-500 md:min-w-[400px]"
  >
    <div class="text-center">
      <p class="mx-auto mb-11 w-full text-base font-bold md:w-96 md:text-xl">
        {{ message }}
      </p>
    </div>
  </div>
</template>
